<template>
  <div></div>
</template>

<script>
export default {
  props: ["step", "meetingInstance"],
};
</script>

